import { useCallback, useEffect, useMemo } from 'react';

const useInfiniteTransactionScroll = (callback: () => void, loading: boolean) => {
    const loadMore = useCallback(
        ([entry]: IntersectionObserverEntry[]) => {
            if (entry.isIntersecting && !loading) {
                callback();
            }
        },
        [callback, loading],
    );

    const observer = useMemo(
        () =>
            new IntersectionObserver(loadMore, {
                root: null,
                rootMargin: '0px',
                threshold: 0.25,
            }),
        [loadMore],
    );

    const ref = useCallback(
        (loadMoreRef: Element | null) => {
            if (loadMoreRef) {
                observer.observe(loadMoreRef);
            }
        },
        [observer],
    );

    useEffect(() => {
        return () => {
            observer.disconnect();
        };
    }, [observer]);

    return ref;
};

export default useInfiniteTransactionScroll;
